import { InvestmentLocationCountryEnum } from "gen/model/investmentLocationCountryEnum";
import { TFunction } from "i18next";

export const formatInvestmentLocationCountry = (
  t: TFunction<["investment"]>,
  country: InvestmentLocationCountryEnum | null | undefined,
) => {
  if (!country) {
    return undefined;
  }
  switch (country) {
    case InvestmentLocationCountryEnum.usa:
      return t("investment:investmentLocations.usa");
    case InvestmentLocationCountryEnum.foreign:
      return t("investment:investmentLocations.foreign");
  }
};
